import { connect, MapDispatchToProps, MapStateToProps } from 'react-redux';
import {
  toggleFeedbackPage,
  toggleBurgerMenuRequested,
  openNotificationsDropdown,
  closeNotificationsDropdown,
} from '../../redux/actions';
import { getFeedbackCount } from '../../../publicSession/selectors';
import { getIsFeedbackPageOpen, getIsNotificationsDropdownOpen } from '../../redux/selectors';
import { Props } from './NotificationsDropdownWrapper';

type StateProps = Pick<
  Props,
  'feedbackCount' | 'isFeedbackPageOpen' | 'isNotificationsDropdownOpen'
>;
type DispatchProps = Pick<
  Props,
  | 'toggleFeedbackPage'
  | 'toggleBurgerMenu'
  | 'openNotificationsDropdown'
  | 'closeNotificationsDropdown'
>;
type OwnProps = Omit<Props, keyof (StateProps & DispatchProps)>;

const mapStateToProps: MapStateToProps<StateProps, OwnProps, any> = state => ({
  isFeedbackPageOpen: getIsFeedbackPageOpen(state),
  isNotificationsDropdownOpen: getIsNotificationsDropdownOpen(state),
  feedbackCount: getFeedbackCount(state),
});

const mapDispatchToProps: MapDispatchToProps<DispatchProps, OwnProps> = {
  toggleFeedbackPage,
  toggleBurgerMenu: toggleBurgerMenuRequested,
  openNotificationsDropdown,
  closeNotificationsDropdown,
};

export default connect(mapStateToProps, mapDispatchToProps);
